import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardContent
} from '@mui/material';
import {
  Cancel as CancelIcon,
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import { THEME_COLORS, THEME_RADIUS } from '../constants/theme';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tripId = searchParams.get('trip_id');

  const handleRetry = () => {
    if (tripId) {
      navigate(`/trips/${tripId}`);
    } else {
      navigate('/trips');
    }
  };

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Card sx={{ 
        borderRadius: THEME_RADIUS.large,
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
      }}>
        {/* Header */}
        <Box sx={{ 
          bgcolor: '#fff3e0',
          color: '#e65100',
          p: 4,
          textAlign: 'center'
        }}>
          <CancelIcon sx={{ fontSize: 80, mb: 2 }} />
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            Payment Cancelled
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            Your payment was not processed
          </Typography>
        </Box>

        {/* Content */}
        <CardContent sx={{ p: 4 }}>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, textAlign: 'center' }}>
            No worries! You can try again anytime to unlock premium features 
            for your trip.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={handleGoBack}
              startIcon={<ArrowBackIcon />}
              sx={{
                py: 1.5,
                borderRadius: THEME_RADIUS.medium,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600
              }}
            >
              Back to Trips
            </Button>

            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleRetry}
              startIcon={<RefreshIcon />}
              sx={{
                backgroundColor: THEME_COLORS.primary.main,
                py: 1.5,
                borderRadius: THEME_RADIUS.medium,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: THEME_COLORS.primary.dark
                }
              }}
            >
              Try Again
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PaymentCancel;
